import { Store } from 'vuex'
import { createStore } from 'vuex-extensions'
import modules from './modules'
import { GLOBAL_SET_LOADING, GLOBAL_SET_FINISHED, GLOBAL_SET_LAST_ACTIVITY } from './types'

export default createStore(Store, {
  state: {
    isGlobalLoading: false,
    lastActivity: null,
  },
  getters: {
    getLastActivity: (state) => state.lastActivity,
  },
  mutations: {
    [GLOBAL_SET_LOADING]: (state) => {
      state.isGlobalLoading = true
    },
    [GLOBAL_SET_FINISHED]: (state) => {
      state.isGlobalLoading = false
    },
    [GLOBAL_SET_LAST_ACTIVITY]: (state) => {
      state.lastActivity = Date.now()
    },
  },
  plugins: [],
  actions: {},
  modules,
})
